import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import StockAdjustmentService from '../services/StockAdjustement';
import { resetState } from './ProdcutionSlice';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  isSuccess: false,
  submitLoading: false,
  adjustOutAllLoading: false,
  adjustOutAllSuccess: false,
};

export const fetchAdjustments = createAsyncThunk(
  'adjustment/all',
  async ({ perPage, page, keyword, type, startDate, endDate, category }) => {
    try {
      const resp = await StockAdjustmentService.All({ perPage, page, keyword, type, startDate, endDate, category });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const createAdjustment = createAsyncThunk(
  'adjustment/createAdjustment',
  async (payload, { rejectWithValue }) => {
    try {
      const resp = await StockAdjustmentService.Create(payload);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const adjustOutAll = createAsyncThunk(
  'adjustment/adjustOutAll',
  async (payload, { rejectWithValue }) => {
    try {
      const resp = await StockAdjustmentService.AdjustOutAll(payload);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const adjustmentAction = createSlice({
  name: 'adjustment',
  initialState: initialState,
  reducers: {
    setFormState: (state, action) => {
      state.formError = []
    },
    resetAdjustOutAll: (state) => {
      state.adjustOutAllSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdjustments.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchAdjustments.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.adjustmentList];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchAdjustments.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createAdjustment.pending, (state, action) => {
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(createAdjustment.fulfilled, (state, action) => {
        state.datas.unshift(action.payload.data.data);
        toast.success(action.payload?.message);
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total + 1,
        };
        state.submitLoading = false;
        state.isSuccess = true;
      })
      .addCase(createAdjustment.rejected, (state, action) => {
        state.submitLoading = false;
        const errors = action.payload?.data?.errors;
        state.isSuccess = false;

        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      // ── Adjust Out All ─────────────────────────────────────────────
      .addCase(adjustOutAll.pending, (state) => {
        state.adjustOutAllLoading = true;
        state.adjustOutAllSuccess = false;
      })
      .addCase(adjustOutAll.fulfilled, (state, action) => {
        state.adjustOutAllLoading = false;
        const responseData = action.payload?.data?.data;
        const count = responseData?.count ?? 0;
        toast.success(`${count} Abnormal Adjustment Out record(s) created.`);
        state.adjustOutAllSuccess = true;
      })
      .addCase(adjustOutAll.rejected, (state, action) => {
        state.adjustOutAllLoading = false;
        state.adjustOutAllSuccess = false;
        toast.error(action.payload?.data?.message || 'Adjust Out All failed.');
      });
  },
});

const { reducer } = adjustmentAction;

export const { setFormState, resetAdjustOutAll } = adjustmentAction.actions;

export const adjustmentSelector = (state) => state?.adjustment;

export default reducer;